module.exports = __webpack_public_path__ + "img/vertical_4_7_8017.7ccc81a7.png";